export default __webpack_public_path__ + "static/media/gh.603ce059.svg";